import { render } from "./Unauthorized.vue?vue&type=template&id=00b9c19b"
import script from "./Unauthorized.vue?vue&type=script&lang=js"
export * from "./Unauthorized.vue?vue&type=script&lang=js"

import exportComponent from "C:\\Projects\\Vind\\Vind\\FomoFront\\VindFrontFomoApp\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__